function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction, isEqual } from '@cloud-sn/v-utils';
import { normalizeContent } from '../utils';
import Selector from '../selector';
import SearchInput from '../searchInput';
export default {
  methods: {
    multipleSearchInputFocus: function multipleSearchInputFocus() {
      var multipleSearchInputRef = this.$refs.multipleSearchInputRef;

      if (multipleSearchInputRef) {
        multipleSearchInputRef.focus();
      }
    },
    stopEventPropagation: function stopEventPropagation(e) {
      e.stopPropagation();
    },
    onRemove: function onRemove(e, value) {
      var removeSelected = this.removeSelected;
      removeSelected(value);
    },
    renderSelections: function renderSelections() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          isMultipleOrTags = this.isMultipleOrTags,
          prevSelections = this.prevSelections,
          placeholderNode = this.placeholderNode,
          getSelectionValue = this.getSelectionValue,
          maxTagCount = this.maxTagCount,
          maxTagTextLength = this.maxTagTextLength,
          maxTagPlaceholder = this.maxTagPlaceholder,
          onRemove = this.onRemove,
          stopEventPropagation = this.stopEventPropagation,
          clearDisabled = this.clearDisabled,
          choiceTranstion = this.choiceTranstion,
          forceUpdateTriggerAlign = this.forceUpdateTriggerAlign;
      var selectionValue = getSelectionValue();
      this.prevSelections = selectionValue;
      var selectionNodes = [];

      if (isMultipleOrTags) {
        var selectionSize = selectionValue.length;
        var selections = selectionValue;
        var maxCnt = Number(maxTagCount);

        if (maxCnt >= 0 && maxCnt < selectionSize) {
          selections = selections.slice(0, maxCnt);
        }

        selectionNodes = selections.map(function (v) {
          var _choiceCls;

          var title = v.title,
              value = v.value,
              selectionContent = v.selectionContent,
              disabled = v.disabled;
          var isCanRemove = !disabled || clearDisabled;
          var choiceCls = (_choiceCls = {}, _defineProperty(_choiceCls, "".concat(prefixCls, "-selection__choice"), true), _defineProperty(_choiceCls, "".concat(prefixCls, "-selection__choice__disabled"), !isCanRemove), _choiceCls);
          return h("li", {
            "key": value,
            "class": choiceCls,
            "on": {
              "click": stopEventPropagation
            },
            "attrs": {
              "title": title || selectionContent
            }
          }, [isCanRemove ? h("span", {
            "class": "".concat(prefixCls, "-selection__choice__remove"),
            "on": {
              "click": function click($event) {
                return onRemove($event, value);
              }
            }
          }) : null, h("span", {
            "class": "".concat(prefixCls, "-selection__choice__content")
          }, [normalizeContent(maxTagTextLength, selectionContent)])]);
        });

        if (maxCnt >= 0 && maxCnt < selectionSize) {
          var tagTxt = "+ ".concat(selectionSize - maxCnt, " ...");

          if (isFunction(maxTagPlaceholder)) {
            var extraSelections = selectionValue.slice(maxCnt);
            tagTxt = maxTagPlaceholder(extraSelections.map(function (v) {
              return v.originNode;
            }));
          } else if (typeof maxTagPlaceholder === 'string') {
            tagTxt = maxTagPlaceholder;
          }

          tagTxt = normalizeContent(maxTagTextLength, tagTxt);
          selectionNodes.push(h("li", {
            "key": "maxTagPlaceholder",
            "attrs": {
              "role": "maxTagPlaceholder"
            },
            "class": "".concat(prefixCls, "-selection__choice ").concat(prefixCls, "-selection__choice__disabled")
          }, [h("span", {
            "class": "".concat(prefixCls, "-selection__choice__content")
          }, [tagTxt])]));
        }
      }

      selectionNodes.push(h("li", {
        "key": "searchInput",
        "class": "".concat(prefixCls, "-search ").concat(prefixCls, "-search--inline")
      }, [h(SearchInput, {
        "ref": "multipleSearchInputRef",
        "attrs": {
          "align": isMultipleOrTags
        }
      })]));
      var listNode = null;

      if (isMultipleOrTags && choiceTranstion) {
        listNode = h("transition-group", {
          "attrs": {
            "name": choiceTranstion,
            "tag": "ul"
          },
          "class": "".concat(prefixCls, "-selection__rendered"),
          "on": {
            "enter": forceUpdateTriggerAlign,
            "after-leave": forceUpdateTriggerAlign
          }
        }, [selectionNodes]);
      } else {
        if (!isEqual(prevSelections, selectionValue)) {
          forceUpdateTriggerAlign();
        }

        listNode = h("ul", {
          "class": "".concat(prefixCls, "-selection__rendered")
        }, [selectionNodes]);
      }

      return h(Selector, {
        "slot": "trigger",
        "attrs": {
          "selections": selectionValue
        }
      }, [listNode, selectionValue.length === 0 ? placeholderNode : null]);
    },
    renderMultipleTrigger: function renderMultipleTrigger() {
      return this.renderSelections();
    }
  }
};